/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnGetAttestation
 */
export interface WebAuthnGetAttestation {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnGetAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnGetAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {object}
     * @memberof WebAuthnGetAttestation
     */
    data?: object;
}

/**
 * Check if a given object implements the WebAuthnGetAttestation interface.
 */
export function instanceOfWebAuthnGetAttestation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "challenge_id" in value;
    isInstance = isInstance && "challenge_type" in value;

    return isInstance;
}

export function WebAuthnGetAttestationFromJSON(json: any): WebAuthnGetAttestation {
    return WebAuthnGetAttestationFromJSONTyped(json, false);
}

export function WebAuthnGetAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnGetAttestation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function WebAuthnGetAttestationToJSON(value?: WebAuthnGetAttestation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
        'challenge_type': ChallengeTypeToJSON(value.challenge_type),
        'data': value.data,
    };
}

